















































import {Component, Vue} from 'vue-property-decorator';
import TimelineTemplate from './views/TimelineTemplate.vue';
import {MACHINE_DATA_STORE_SERVICE_INSTANCE} from './services/machines/machine-timeline-data-store.service';
import {DataGroup, DataItem, TimelineEventPropertiesResult} from 'vis-timeline/esnext';
import TimelineDialogTemplate from '@/views/timeline/views/TimelineDialogTemplate.vue';
import moment from 'moment';

@Component({
    components: {
        TimelineTemplate,
        TimelineDialogTemplate
    }
})
export default class MachineTimelineTemplate extends Vue {

    dataProvider = MACHINE_DATA_STORE_SERVICE_INSTANCE;

    editOrder: DataItem | null = null; // the current order to be edited
    editMachine: DataGroup | null = null; // the current machine to be edited

    stopEditOrder() {
        // after edit is complete (dialog is closed).
        // delete the dialog in the DOM again by invalidating v-if=editOrder
        this.editOrder = null;
    }

    stopEditMachine() {
        // after edit is complete (dialog is closed).
        // delete the dialog in the DOM again by invalidating v-if=editMachine
        this.editMachine = null;
    }

    onClick(event: TimelineEventPropertiesResult) {
        switch (event.what) {
            case 'item': {
                // clicked on a item
                if (event.item) {
                    const lookupOrderFromIndex =
                        this.dataProvider.getItemIndex().get(event.item);
                    if (lookupOrderFromIndex) {
                        this.editOrder = lookupOrderFromIndex;
                    }
                }
                break;
            }
            case 'group-label': {
                // clicked on a group OR subgroup
                const key: any = event.group; // type mapping is wrong. IDType is the correct one
                const lookupMachineFromIndex =
                    this.dataProvider.getMachinesIndex().get(key);
                if (lookupMachineFromIndex) {
                    // machine found
                    this.editMachine = lookupMachineFromIndex;
                }
            }
            default: {
                break;
            }
        }
    }

    formatDateTime(date: Date): string {
        return moment(date).format('DD.MM.YYYY HH:MM');
    }
}
